import { ErrorBlock } from '@/components/ErrorBlock'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgJobRatingUrl from '@/assets/misc/img_job-rating.svg'
import RatingsIllustration from '@/components/SpotIllustration/RatingsIllustration'

export interface CloseJobAsCollaboratorDialogProps {
  showing: boolean
  corporateMode: boolean
  isSubmitPending: boolean
  isSubmitRejected: boolean
  submitError?: unknown
  onClose: () => unknown
  onSubmit: () => unknown
  onDismissError: () => unknown
  submitButtonTestId?: string
}

export function CloseJobAsCollaboratorDialog({
  showing,
  corporateMode,
  isSubmitPending,
  isSubmitRejected,
  submitError,
  onClose,
  onSubmit,
  onDismissError,
  submitButtonTestId,
}: CloseJobAsCollaboratorDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSubmitPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgJobRatingUrl}
              illustration={byDesign(undefined, RatingsIllustration)}
              alt="Illustration of a finger tapping a star rating on a phone"
            />
          )}
          <CloseJobDialogHeaderContent />
        </ModalSheetContentBlock>
      </ModalSheetContent>
      {isSubmitRejected && (
        <ErrorBlock
          tackOn="bottom"
          error={submitError}
          onClose={() => onDismissError()}
        />
      )}
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            onPress={onClose}
            isDisabled={isSubmitPending}
          />
          <Button
            label="Complete"
            variant="primary"
            onPress={onSubmit}
            isDisabled={isSubmitPending}
            isPending={isSubmitPending}
            testId={submitButtonTestId}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}

function CloseJobDialogHeaderContent() {
  return (
    <>
      <ModalSheetContentTitle>Complete Job</ModalSheetContentTitle>
      <ModalSheetContentDescription compact>
        By marking this job as completed, communication with the client will
        cease.
      </ModalSheetContentDescription>
    </>
  )
}
